















import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import RouteNames from "@/router/RouteNames";

@Component
export default class AppFooter extends Vue {
  get currentYear(): string {
    return moment().format("YYYY");
  }

  get RouteNames() {
    return RouteNames;
  }
}
